import React from 'react'
import SwaggerUI from 'swagger-ui-react'
import "swagger-ui-react/swagger-ui.css"
import Footer from './Footer/Footer'
import Header from './Header/Header'

// Import Unified Hosting Swagger Spec
import { SwaggerUnifiedHostingSpec } from '../spec/UnifiedHostingSpec';


function SwaggerUhokta() {
  const DisableTryItOutPlugin = function () {
    return {
      statePlugins: {
        spec: {
          wrapSelectors: {
            allowTryItOutFor: () => () => false
          }
        }
      }
    }
  }
  return (
    <div className="App">
      <Header />
      <SwaggerUI spec={SwaggerUnifiedHostingSpec} plugins={DisableTryItOutPlugin} />
      <footer className="FooterClass">
        <Footer />
      </footer>
    </div>
  )
}

export default SwaggerUhokta
